import { Ref } from 'vue';
import { keepPreviousData, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from './_http';
//업종 테마 조회
type GetSectorThemeParams = Ref<{
	category: string;
}>;
export type GetSectorThemeResType = {
	sector_theme: SectorTheme[];
};
export type SectorTheme = {
	rise_rate_pk: number;
	rise_rate_category_name: string;
	image_path: string;
};
export const useGetSectorThemeApi = (params: GetSectorThemeParams) => {
	const url = '/v1/front/usa/getSectorTheme';
	return useQuery<AxiosResponse, AxiosError, GetSectorThemeResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		staleTime: 1000 * 60 * 5,
		placeholderData: keepPreviousData,
	});
};

// 상승률 상위 업종 테마 조회
type GetRiseSectorThemeParams = Ref<{
	home_yn: number;
	category: string;
	period: string;
}>;
export type GetRiseSectorThemeResType = {
	rise_sector_theme: RiseSectorTheme[];
};
export type RiseSectorTheme = {
	image_path: string;
	rise_rate_category_name: string;
	rise_rate_pk: number;
	rise_rate_weekly_rate?: string;
	rise_rate_monthly_rate?: string;
	rise_rate_quarterly_rate?: string;
	rise_rate_annual_rate?: string;
};
export const useGetRiseSectorThemeApi = (params: GetRiseSectorThemeParams) => {
	const url = '/v1/front/usa/getRiseSectorTheme';
	return useQuery<AxiosResponse, AxiosError, GetRiseSectorThemeResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		placeholderData: keepPreviousData,
	});
};
// 상승률 상위 업종 테마 상세 조회
type GetRiseSectorThemeDetailParams = {
	rise_rate_pk: string;
};
export type GetRiseSectorThemeDetailResType = {
	sector_theme_detail: RiseSectorThemeDetail;
	event_ratio: EventRatio[];
	events: EventGroup;
};
export type EventGroup = {
	[key: string]: DetailEvent[]; // 동적 키로 각 섹터("장비", "소재" 등)를 정의
};
export type DetailEvent = {
	bookmark: number;
	event_name: string;
	event_pk: number;
	event_ticker: string;
	file_pk: number;
};
export type EventRatio = {
	cap_percentage: number;
	event_name: string;
};

export type RiseSectorThemeDetail = {
	image_path: string;
	rise_rate_category_name: string;
	rise_rate_introduction: number;
	rise_rate_weekly_rate?: string;
	rise_rate_monthly_rate?: string;
	rise_rate_quarterly_rate?: string;
	rise_rate_annual_rate?: string;
};
export const useGetRiseSectorThemeDetailApi = (params: Ref<GetRiseSectorThemeDetailParams>) => {
	const url = '/v1/front/usa/getRiseSectorThemeDetail';
	return useQuery<AxiosResponse, AxiosError, GetRiseSectorThemeDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		placeholderData: keepPreviousData,
	});
};
